// path: pages/_app.jsx
import Head from 'next/head';
import Navbar from '@/Components/Navbar';
import Footer from '@/Components/Footer';
import AppBase from 'next/app';
import { useEffect } from 'react';

export default function App({ Component, pageProps }) {
  const { footerData = {}, newsTypesObject, searchQuery, pageType } = pageProps;

  // path: pages/_app.jsx - في صفحة الريلز نبقي Navbar ظاهر ونخفي Footer فقط
  const hideFooterOnReels = pageType === 'reels';

  // path: pages/_app.jsx - في صفحتي النجاح والإلغاء نخفي Navbar و Footer بالكامل
  const hideLayoutChrome = pageType === 'success' || pageType === 'cancel';

  useEffect(() => {
    const disableZoom = (e) => {
      if (e.ctrlKey) e.preventDefault();
    };

    const disableKeyZoom = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        (e.key === '+' || e.key === '-' || e.key === '=')
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener('wheel', disableZoom, { passive: false });
    window.addEventListener('keydown', disableKeyZoom);

    return () => {
      window.removeEventListener('wheel', disableZoom);
      window.removeEventListener('keydown', disableKeyZoom);
    };
  }, []);

  return (
    <>
      <Head>
        <title>يؤثرون</title>
        <meta name="description" content="منصة يؤثرون للتبرعات" />
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, viewport-fit=cover"
        />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <link rel="icon" href="/images/Afaq.jpg" type="image/jpeg" />
      </Head>

      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {!hideLayoutChrome && (
          <Navbar
            pageType={pageType}
            newsTypesObject={newsTypesObject}
            searchQuery={searchQuery}
          />
        )}

        <main style={{ flex: 1 }}>
          <Component {...pageProps} />
        </main>

        {!hideLayoutChrome && !hideFooterOnReels && <Footer footer={footerData} />}
      </div>
    </>
  );
}

App.getInitialProps = async (appContext) => {
  const appProps = await AppBase.getInitialProps(appContext);
  const { ctx } = appContext;
  const isServer = !!ctx.req;
  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL || '';
  const footerApiUrl = isServer ? `${baseUrl}/api/footerConfig` : `/api/footerConfig`;

  let footerData = {};
  try {
    const res = await fetch(footerApiUrl);
    if (res.ok) {
      footerData = await res.json();
    } else {
      console.error('Failed to fetch footerConfig, status:', res.status);
    }
  } catch (err) {
    console.error('Error loading footerConfig:', err);
  }

  const newsTypesObject = {
    all: 'الكل',
    campaigns: 'الحملات',
    humanCases: 'الحالات الإنسانية',
    achievements: 'الإنجازات',
  };

  const { pathname, query } = appContext.ctx;
  let pageType = 'index';

  if (pathname === '/') {
    pageType = 'index';
  } else if (pathname === '/success') {
    // path: pages/_app.jsx - تعريف صفحة النجاح لإخفاء Navbar و Footer
    pageType = 'success';
  } else if (pathname === '/cancel') {
    // path: pages/_app.jsx - تعريف صفحة الإلغاء لإخفاء Navbar و Footer
    pageType = 'cancel';
  } else if (pathname.startsWith('/reels')) {
    // path: pages/_app.jsx - تعريف صفحة الريلز حتى يتعامل معها Navbar/Footer بشكل خاص
    pageType = 'reels';
  } else if (pathname === '/news/type/[type]' || pathname.startsWith('/news/type/')) {
    const newsType = query.type || 'all';
    pageType = `news-${newsType}`;
  } else if (pathname === '/news') {
    const newsType = query.type || 'all';
    pageType = `news-${newsType}`;
  } else if (pathname === '/news/[id]') {
    pageType = 'news-all';
  } else if (pathname.startsWith('/aboutUs')) {
    pageType = 'aboutUs';
  } else if (pathname.startsWith('/contactUs')) {
    pageType = 'contactUs';
  } else if (pathname.startsWith('/donate')) {
    pageType = 'donate';
  }

  const searchQuery = query.search || '';

  return {
    ...appProps,
    pageProps: {
      ...appProps.pageProps,
      footerData,
      newsTypesObject,
      pageType,
      searchQuery,
    },
  };
};
